import React from 'react'

import { API, CEGID } from 'services';

import { AbstractContainer } from 'containers';

import { ClinicScene } from 'scenes';

class ClinicContainer extends AbstractContainer {

  getTasks(params) {

    let clinic = parseInt(params.clinic);

    return [
      {
        key: 'clinic',
        exec: (done, failure) => {
          API.get(`clinics/${clinic}`)
            .then((response) => {
              done(response.data);
            })
            .catch(failure);
        }
      },
      {
        key: 'devices',
        exec: (done, failure) => {
          API.get(`clinics/${clinic}/devices`)
            .then((response) => {
              done(response.data);
            })
            .catch(failure);
        }
      },
      {
        key: 'invoices',
        exec: (done, failure) => {

          CEGID.get(`/getInvoicesFromEmail`, {email: clinic.email})
            .then((response) => {
              done(response);
            })
            .catch(failure);
        }
      }
    ]
  }

  getComponent(results) {
    return <ClinicScene clinic={results.clinic} devices={results.devices} invoices={results.invoices} />
  }
}

export default ClinicContainer;
